import { SharedModule } from './../../shared/shared.module';
import { NgModule } from '@angular/core';
import { PatientMergeComponent } from './patient-merge.component';
import { PatientMergeSelectorComponent } from './patient-merge-selector/patient-merge-selector.component';
import { MemberListService } from 'src/app/core/service/grid-data/grid-data-member.service';
import { DocumentViewerModule } from 'src/app/shared/document-viewer/document-viewer.module';

@NgModule({
    declarations: [
        PatientMergeComponent,
        PatientMergeSelectorComponent
    ],
    imports: [
        SharedModule,
        DocumentViewerModule
    ],
    exports: [
        PatientMergeComponent,
        PatientMergeSelectorComponent
    ],
    providers: [
        MemberListService
    ]
})
export class PatientMergeModule { }
